export class DocumentStatus {
  private constructor(public readonly value: string) {}

  static readonly none = new DocumentStatus("None");
  static readonly delete = new DocumentStatus("Delete");
  static readonly resubmit = new DocumentStatus("Resubmit");
  static readonly reject = new DocumentStatus("Reject");
  static readonly approve = new DocumentStatus("Approve");
  static readonly cancel = new DocumentStatus("Cancel");
  static readonly submit = new DocumentStatus("Submit");

  static getType(status: string): DocumentStatus {
    switch (status) {
      case "None":
        return DocumentStatus.none;
      case "Delete":
        return DocumentStatus.delete;
      case "Resubmit":
        return DocumentStatus.resubmit;
      case "Reject":
        return DocumentStatus.reject;
      case "Approve":
        return DocumentStatus.approve;
      case "Cancel":
        return DocumentStatus.cancel;
      case "Submit":
        return DocumentStatus.submit;
      default:
        return DocumentStatus.none;
    }
  }

  static getColorByStrCode(status: string): string {
    switch (status) {
      case "None":
        return "#000000";
      case "Delete":
        return "#DC2626";
      case "Resubmit":
        return "#6366F1";
      case "Reject":
        return "#F43F5E";
      case "Approve":
        return "#22C55E";
      case "Cancel":
        return "#9CA3AF";
      case "Submit":
        return "#3B82F6";
      default:
        return "#000000";
    }
  }
  static getColorByStr(status: string): string {
    switch (status) {
      case "None":
        return "bg-black-500";
      case "Draft":
        return "bg-gray-500";
      case "Pending":
        return "bg-yellow-500";
      case "Approved":
        return "bg-green-500";
      case "Cancelled":
        return "bg-red-500";
      case "Rejected":
        return "bg-red-500";
      default:
        return "bg-black";
    }
  }

  static getColorByType(status: DocumentStatus): string {
    switch (status) {
      case DocumentStatus.none:
        return "#000000";
      case DocumentStatus.delete:
        return "#DC2626";
      case DocumentStatus.resubmit:
        return "#6366F1";
      case DocumentStatus.reject:
        return "#F43F5E";
      case DocumentStatus.approve:
        return "#22C55E";
      case DocumentStatus.cancel:
        return "#9CA3AF";
      case DocumentStatus.submit:
        return "#3B82F6";
      default:
        return "#000000";
    }
  }
}

